import React from 'react';
import { connect } from 'react-redux';
import VesselClaimsItem from './Item';

class VesselClaimsList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { vesselClaims: { items } } = this.props;

        if (!items) {
            return null;
        }

        return (
            <div>
                <div>
                    <ul className='list-claims'>
                        {
                            items.map((item, key) => <VesselClaimsItem key={key} item={item} />)
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ vesselClaims }) => {
        return {
            vesselClaims,
        };
    },
)(VesselClaimsList);



// WEBPACK FOOTER //
// ./app/components/Vessels/Claims/List.jsx